import { CONFIG } from "../../../config";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const CRMCONFIG = CONFIG.modules["crm"];
const API_HOST_CRM = CRMCONFIG.host;

export const useGetDailyCaseAnalytics = (from, to) => {
  const fetchDailyCaseAnalytics = async () => {
    try {
      const response = await axios.get(
        `${API_HOST_CRM}/analytics/daily-case-analytics`,
        {
          params: { from, to },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching daily case analytics:", error);
      throw error;
    }
  };

  return useQuery({
    queryKey: ["dailyCaseAnalytics", from, to],
    queryFn: fetchDailyCaseAnalytics,
    refetchOnWindowFocus: false,
    retry: 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    onError: (error) => {
      console.error("Error in useGetDailyCaseAnalytics:", error);
    },
  });
};
